{
  "version": 1,
  "asset_id": "0d37cb19-9daa-41d8-b6ec-e845c7e11811",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/0d37cb19-9daa-41d8-b6ec-e845c7e11811/hiatal-normal-v3-1200.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/0d37cb19-9daa-41d8-b6ec-e845c7e11811/hiatal-normal-v3-1200.jpg",
  "original_filename": "hiatal-normal-v3-1200.jpg",
  "size": 230012,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T23:12:02Z"
}
